import React, {useState} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';
import NewLocationButton from './NewLocationButton';
import { Biscuit, Notification } from "../../../../utils";

const LocationsSidebar = (props) => {

    const locationClassNamePrefix = "inb-location-";
    const user_role = Biscuit.get('user.role');
    const [results,setResults] = useState([]);

    const locationSearchHandler = (ev) => {

        if (ev.target.value.length == 0) {
            updateResultList();
            return;
        }
        
        // query local collection of locations
        var list = [];
        const query = ev.target.value.toLowerCase();
        for (var i=0;i<props.locations.length;i++) {
            if (props.locations[i].name.toLowerCase().indexOf(query) >= 0) {
                list.push(props.locations[i]);
                list[list.length-1].listIndex = i;
            } 
        }
        setResults(list);
    };

    const updateResultList = () => {

        const el = document.getElementById('_locationsList__search');

        if (typeof el !== 'undefined' && el !== null && el.value.length == 0) {
            if (typeof props.locations !== 'undefined' && props.locations !== null && results.length != props.locations.length) {
                let el = [...props.locations];
                for (var i=0;i<props.locations.length;i++) {
                    el[i].listIndex = i;
                }
                setResults(el);
            }
        }
    };
    const hasPerm =  (user_role === 'admin' || user_role === 'manager' || user_role === 'manager_location');

    updateResultList();

    return (
        <>
            <header className="inb-c-left-bar__title">
                <h1 className="inb-page-title" style={{fontSize:'1.55rem'}}>
                {t('locations',null,'capital')} ({results.length})
                </h1>
            </header>
            
            

            <ul className="inb-vert-list">
                <span className="inb-list-title">Liste der Standorte</span>
                <input type="text" id="_locationsList__search" placeholder="Standorte durchsuchen..." maxLength="255" onChange={(e) => locationSearchHandler(e)}/>
                { typeof results.map === 'function' &&
                <div id="locationsList__content">
                     {results.map((location, index) => {
                        return (
                            <>
                                <li className="locationsListItem">
                                    <span className={locationClassNamePrefix + location.id}>
                                    { hasPerm ? <a className="location__edit" href={`/locations/${location.id}`}>{location.name}</a> : location.name }
                                    </span>
                                </li>
                            </>
                        );
                    })}
                </div>
                }
            </ul>
      </>  
    );
};

export default LocationsSidebar;